const $window = $(window);
let windowWidth = $window.width();
var _isTest = false;

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

// pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {

  if(_isTest) {

    $('#st-Loader').remove();
    $('.js-loadingAnimation').addClass("is-animated");
    scrollIndexAnime();

  }else {
    setTimeout(function(){$('#st-Loader .st-Loader_Logo').addClass("load");},400);
    setTimeout(function(){$('#st-Loader').addClass("hidden");},1200);
    setTimeout(function(){$('#st-Loader').remove();},1600);

    setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},1600);

    scrollIndexAnime();
    // KVglitch();
  }

});



// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  // //シーンを作成
  // const scene = new ScrollMagic.Scene({
  //     triggerElement: target,
  //     triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-News',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //バンド背景
  // const scene2 = new ScrollMagic.Scene({
  //   triggerElement:'#index-Afterglow',
  //   triggerHook: 1,
  //   offset: '0'
  // })
  // .setClassToggle('#index-Bg', 'afterglow')
  // .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .8
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });


  new ScrollMagic.Scene({
    triggerElement: "#roselia",
    duration: "100%"
  })
    .setClassToggle("#item-roselia", "active")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#poppinparty",
    duration: "100%"
  })
    .setClassToggle("#item-poppinparty", "active")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#hello-happy-world",
    duration: "100%"
  })
    .setClassToggle("#item-hello-happy-world", "active")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#pastel-palettes",
    duration: "100%"
  })
    .setClassToggle("#item-pastel-palettes", "active")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#afterglow",
    duration: "100%"
  })
    .setClassToggle("#item-afterglow", "active")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

  // new ScrollMagic.Scene({
  //   triggerElement: "#pastel-palettes_Inner",
  //   triggerHook: .05,
  //   duration: 700
  // })
  //   .setPin("#pastel-palettes_Inner")
  //   // .addIndicators() // add indicators (requires plugin)
  //   .addTo(controller);


  new ScrollMagic.Scene({
    triggerElement: "#roselia",
    duration: "100%"　//追加したら変える
  })
    .setClassToggle("#index-Bg", "roselia")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#poppinparty",
    // duration: "100%"　//追加したら変える
  })
    .setClassToggle("#index-Bg", "poppinparty")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#hello-happy-world",
    // duration: "100%"
  })
    .setClassToggle("#index-Bg", "hello-happy-world")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#pastel-palettes",
    // duration: "100%"
  })
    .setClassToggle("#index-Bg", "pastel-palettes")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#afterglow",
    // duration: "100%"
  })
    .setClassToggle("#index-Bg", "afterglow")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  new ScrollMagic.Scene({
    triggerElement: "#index-Band",
    triggerHook: .5,
    // duration: "100%"
  })
    .setClassToggle("#index-Navi", "show")
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

};



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js